var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#868686"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6 27c-1.5 0-2 .9-1.2 2.1 0 0 14.7 16.7 15.2 17.3.9.8 2.1.8 3 0 .5-.6 15.1-17.3 15.1-17.3.8-1.1.3-2.1-1.2-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2h15v27h-15zM56 44v10H8V44H0v18h64V44z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiM4Njg2ODYiPjxwYXRoIGQ9Im0xNi42IDI3Yy0xLjUgMC0yIC45LTEuMiAyLjEgMCAwIDE0LjcgMTYuNyAxNS4yIDE3LjMuOS44IDIuMS44IDMgMCAuNS0uNiAxNS4xLTE3LjMgMTUuMS0xNy4zLjgtMS4xLjMtMi4xLTEuMi0yLjF6Ii8+PHBhdGggZD0ibTI0LjUgMmgxNXYyN2gtMTV6Ii8+PHBhdGggZD0ibTU2IDQ0djEwaC00OHYtMTBoLTh2OS43IDguM2g4LjEgNDcuOCA1LjUgMi42di0xOHoiLz48L2c+PC9zdmc+Cg==";
export { SvgDownload as ReactComponent };